import { Module } from 'vuex';
import { LendingRecordState } from './types';
import { RootState } from '../../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: LendingRecordState = {
    lendingRecords: undefined,
    lendingRecordCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

export const privilegeIdLendingRecord: Module<LendingRecordState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
